export default __webpack_public_path__ + "static/media/FitnesTestAndMeasureTest.17f38367.png";